import { render, staticRenderFns } from "./PhoneColumn.vue?vue&type=template&id=49725eca"
import script from "./PhoneColumn.vue?vue&type=script&lang=js"
export * from "./PhoneColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports